import React from "react";
import useIsMobile from "lib/hooks/useIsMobile";
import { ViewModeToggleButtons } from "pages/latestResearch/publications/toolbar/parts/ViewModeToggleButtons";
import { MobileFilterButton } from "pages/redesign/menuFilterBar/parts/FilterButton";
import { OrderByDropdownRedesign } from "./OrderByDropdown";

export const Toolbar = ({ viewMode, setViewMode, searchResults }) => {
  const isMobile = useIsMobile();

  return (
    <section className="d-flex flex-row align-items-center mb-2 overflow-x-auto">
      <OrderByDropdownRedesign />
      <div className="ml-auto flex-shrink-0">
        {isMobile && <MobileFilterButton searchResults={searchResults} />}
        <ViewModeToggleButtons viewMode={viewMode} setViewMode={setViewMode} className="m-0" />
      </div>
    </section>
  );
};
